import { render, staticRenderFns } from "./ProductoCategoriaUpdate.vue?vue&type=template&id=48cbb5e4&scoped=true&"
import script from "./ProductoCategoriaUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductoCategoriaUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbb5e4",
  null
  
)

export default component.exports